import { toEnum } from '@tryiris-ai/js-types';
import type { T_Maybe } from '@tryiris-ai/js-types';
import { Arrangement } from './types.js';

/**
 * Transforms the specified value to an `Arrangement` enumeration.
 *
 * @param value - The value to be transformed.
 * @returns The transformed `Arrangement` enumeration or `undefined`.
 */
export const toArrangement = (value: unknown): T_Maybe<Arrangement> =>
  toEnum(Arrangement, value, {
    aliases: {
      [Arrangement.Multiple]: ['g', 'multi'],
      [Arrangement.Single]: ['s']
    }
  });
